import React from 'react';
import classnames from 'classnames';
import Body from './body';
import Footer from './footer';
import Header, { HeaderProps } from './header';
import { PageProps } from './types';
import styles from './index.module.scss';

function Page({
  children,
  'data-test-id': dataTestId,
  className,
  variant = 'default',
  ...additionalProps
}: React.PropsWithChildren<PageProps>) {
  const pageClasses = classnames(styles.page, className);

  return (
    <div
      className={pageClasses}
      data-test-id={`${dataTestId}-wrapper`}
      {...Object.fromEntries(
        Object.entries(additionalProps).filter(([key]) =>
          key.startsWith('data-'),
        ),
      )}
    >
      {React.Children.map(children, (child) => {
        // @ts-ignore
        const isValid = [Header, Body, Footer, undefined].includes(child?.type);

        if (!isValid) {
          return 'Invalid Page Children. Page children can be of Header , Body or Footer';
        }

        if (
          // @ts-ignore
          child?.type === Header &&
          React.isValidElement<HeaderProps>(child)
        ) {
          return React.cloneElement(child, {
            variant,
          });
        }
        return child;
      })}
    </div>
  );
}

Page.Header = Header;
Page.Body = Body;
Page.Footer = Footer;

export default Page;
